// Demo mode flag for the public iuvotech.com Guardian demo.
//
// When VITE_DEMO_MODE === 'true' the SPA boots without MSAL, the api
// client returns canned data from src/lib/demo/dataset.ts, and the
// fictional `Contoso` tenant is the only thing visible.
//
// Demo builds run with no AZURE_*, no Graph permissions, and no real
// API base URL — every code path that would have used those is gated.

export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true'

// Backing dataset is a sanitized export of Microsoft's CDX "Contoso"
// demo tenant from iuvo-guardian-db-dev. Tenant GUID is preserved
// as-exported so every row in the JSON files (drifts, violations,
// users, oauth apps, etc.) keys back to the same id correctly.
export const DEMO_TENANT_ID = '223f854d-f453-4f15-a802-ca19dba2fd33'
export const DEMO_TENANT_NAME = 'Contoso'
export const DEMO_TENANT_DOMAIN = 'contoso.onmicrosoft.com'
